import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { Bau365DataAccessFairDataModule } from '@planone/bau365/data-access-fair-data';
import { Bau365DataAccessSearchModule } from '@planone/bau365/data-access-search';
import { Bau365FeatureBreadcrumbModule, BreadcrumbHelper } from '@planone/bau365/feature-breadcrumb';
import { Bau365FeatureContactPersonModule } from '@planone/bau365/feature-contact-person';
import { Bau365FeatureEventsSharedModule } from '@planone/bau365/feature-events';
import { Bau365FeaturePostsSharedModule } from '@planone/bau365/feature-posts';
import { Bau365FeatureProductsSharedModule } from '@planone/bau365/feature-products';
import { Bau365FeatureRestrictedAccessModule } from '@planone/bau365/feature-restricted-access';
import { Bau365FeatureUserProfileSharedModule } from '@planone/bau365/feature-user-profile';
import { Bau365FeatureWatchlistSharedModule } from '@planone/bau365/feature-watchlist';
import { Bau365UiShellModule } from '@planone/bau365/ui-shell';
import { SharedUtilFeatureFlagsModule } from '@planone/shared/data-access-feature-flags';
import { SharedDataAccessSwiperModule } from '@planone/shared/data-access-swiper';
import { SharedUiElementsModule } from '@planone/shared/ui-elements';
import { SharedUiIconsModule } from '@planone/shared/ui-icons';
import { SharedUtilMetaModule } from '@planone/shared/util-meta';
import { SharedUtilPipelinesModule } from '@planone/shared/util-pipelines';
import { BreadcrumbGenerator } from '@planone/shared/util-structured-data';
import { SharedUiSwiperModule } from '@planone/shared-feature-swiper';

import { Bau365FeatureExhibitorsSharedModule } from './bau365-feature-exhibitors-shared.module';
import { DisplayNameSearchInputComponent } from './display-name-search-input/display-name-search-input.component';
import { ExhibitorDirectoryInvalidUrlRedirectGuard } from './guards/exhibitor-directory-invalid-url-redirect.guard copy';
import { ExhibitorDirectoryRedirectGuard } from './guards/exhibitor-directory-redirect.guard';
import { ScrollPositionGuard } from './guards/scroll-position.guard';
import { PageExhibitorContactPersonDetailsComponent } from './page-exhibitor-contact-person-details/page-exhibitor-contact-person-details.component';
import { PageExhibitorDetailsComponent } from './page-exhibitor-details/page-exhibitor-details.component';
import { ParallaxAdvertisementComponent } from './page-exhibitor-directory/advertisements/parallax-advertisement/parallax-advertisement.component';
import { SkyscraperAdvertisementComponent } from './page-exhibitor-directory/advertisements/skyscraper-advertisement/skyscraper-advertisement.component';
import { DirectoryListItemComponent } from './page-exhibitor-directory/directory-list-item/directory-list-item.component';
import { PageExhibitorDirectoryComponent } from './page-exhibitor-directory/page-exhibitor-directory.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild([
      {
        path: ':id/contact/:contactPersonIndex',
        pathMatch: 'full',
        component: PageExhibitorContactPersonDetailsComponent,
        data: {
          userSessionRequired: true,
          analyticsPageType: 'contact-person',
          googleAnalytics: {
            customTracking: true,
          },
          snowplow: {
            customTracking: true,
          },
        },
      },
      {
        path: 'letters',
        canDeactivate: [ScrollPositionGuard],
        pathMatch: 'full',
        canActivate: [ExhibitorDirectoryInvalidUrlRedirectGuard],
        component: PageExhibitorDirectoryComponent,
        data: {
          analyticsPageType: 'exhibitors',
          googleAnalytics: {
            customTracking: true,
          },
          snowplow: {
            customTracking: true,
          },
        },
      },
      {
        path: 'halls',
        canDeactivate: [ScrollPositionGuard],
        pathMatch: 'full',
        canActivate: [ExhibitorDirectoryInvalidUrlRedirectGuard],
        component: PageExhibitorDirectoryComponent,
        data: {
          analyticsPageType: 'exhibitors',
          googleAnalytics: {
            customTracking: true,
          },
          snowplow: {
            customTracking: true,
          },
        },
      },
      {
        path: 'search',
        pathMatch: 'full',
        component: PageExhibitorDirectoryComponent,
        data: {
          analyticsPageType: 'exhibitors',
          googleAnalytics: {
            customTracking: true,
          },
          snowplow: {
            customTracking: true,
          },
        },
      },
      {
        path: ':id',
        pathMatch: 'full',
        component: PageExhibitorDetailsComponent,
        data: {
          analyticsPageType: 'exhibitor-details',
          googleAnalytics: {
            customTracking: true,
          },
          snowplow: {
            customTracking: true,
          },
        },
      },
      {
        path: '',
        pathMatch: 'full',
        canActivate: [ExhibitorDirectoryRedirectGuard],
        component: PageExhibitorDirectoryComponent,
        data: {
          analyticsPageType: 'exhibitors',
        },
      },
    ]),
    SharedDataAccessSwiperModule,
    Bau365DataAccessFairDataModule,
    Bau365DataAccessSearchModule,
    MatCardModule,
    MatIconModule,
    MatChipsModule,
    MatTooltipModule,
    SharedUtilPipelinesModule,
    MatTabsModule,
    SharedUiElementsModule,
    MatButtonModule,
    Bau365UiShellModule,
    SharedUiSwiperModule,
    SharedUtilMetaModule,
    SharedUiIconsModule,
    Bau365FeatureWatchlistSharedModule,
    Bau365FeatureRestrictedAccessModule,
    Bau365FeatureProductsSharedModule,
    Bau365FeaturePostsSharedModule,
    Bau365FeatureExhibitorsSharedModule,
    Bau365FeatureEventsSharedModule,
    Bau365FeatureContactPersonModule,
    Bau365FeatureBreadcrumbModule,
    Bau365FeatureBreadcrumbModule,
    Bau365FeatureUserProfileSharedModule,
    SharedUtilFeatureFlagsModule,
  ],
  declarations: [
    PageExhibitorDetailsComponent,
    PageExhibitorDirectoryComponent,
    DirectoryListItemComponent,
    ParallaxAdvertisementComponent,
    SkyscraperAdvertisementComponent,
    PageExhibitorContactPersonDetailsComponent,
    DisplayNameSearchInputComponent,
  ],
  providers: [BreadcrumbGenerator, BreadcrumbHelper],
})
export class Bau365FeatureExhibitorsModule {}
